module.exports = __webpack_public_path__ + "static/media/03_RB@3x.869c9d22.png";